import React from 'react';

export default function Refresh(props) {
  return (
    <svg preserveAspectRatio="xMidYMid" viewBox="0 0 44 48" {...props}>
      <path d="M34.231,40.715 C33.777,41.026 33.153,40.909 32.842,40.452 C32.530,39.996 32.648,39.374 33.104,39.063 C38.508,35.375 42.000,28.678 42.000,22.000 C42.000,10.972 33.028,2.000 22.000,2.000 C10.972,2.000 2.000,10.972 2.000,22.000 C2.000,33.028 10.972,42.000 22.000,42.000 C22.270,42.000 22.537,41.966 22.807,41.956 L20.210,38.614 C19.871,38.178 19.950,37.549 20.387,37.210 C20.822,36.871 21.452,36.951 21.790,37.386 L25.790,42.534 C25.962,42.755 26.033,43.040 25.985,43.316 C25.938,43.593 25.776,43.837 25.540,43.989 L19.540,47.841 C19.373,47.949 19.186,48.000 19.001,48.000 C18.672,48.000 18.350,47.838 18.158,47.540 C17.860,47.076 17.995,46.457 18.460,46.159 L21.835,43.992 C9.780,43.901 0.000,34.075 0.000,22.000 C0.000,9.869 9.869,-0.000 22.000,-0.000 C34.131,-0.000 44.000,9.869 44.000,22.000 C44.000,29.319 40.166,36.666 34.231,40.715 Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/rotate.js